import React from 'react';
import { Image } from '../../../images/image';
import {
  ProgressCircle_Active,
  ProgressCircle_Complete,
  ProgressCircle_Default,
} from './images';
import { StepState } from '../stepState';

export interface StepVisualProps {
  stepState: StepState;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

const StepVisual: React.FC<StepVisualProps> = (props: StepVisualProps) => {
  let imageSource = ProgressCircle_Default;
  let alternateText = 'Incomplete';

  if (props.stepState === StepState.Active) {
    imageSource = ProgressCircle_Active;
    alternateText = 'Active';
  } else if (props.stepState === StepState.Complete) {
    imageSource = ProgressCircle_Complete;
    alternateText = 'Complete';
  }

  return (
    <div
      onMouseEnter={() => props.onMouseEnter()}
      onMouseLeave={() => props.onMouseLeave()}
      onClick={() => props.onClick()}
    >
      <Image
        height={26}
        width={26}
        source={imageSource}
        alternateText={alternateText}
      />
    </div>
  );
};

export default StepVisual;
